import * as React from "react";
function SvgDiscPause(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={6.06}
        d="M31.5 14v20M16.5 14v20"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDiscPause);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
